import React, { useMemo } from 'react';
import type { TaskTemplateRecord, TemplatePhase } from './templateManagementService';
import { formatJurisdictionLabel } from './templateManagementService';

interface TemplateDetailCourtInfoProps {
  template: TaskTemplateRecord;
  phases: TemplatePhase[];
}

const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

const TemplateDetailCourtInfo: React.FC<TemplateDetailCourtInfoProps> = ({ template, phases }) => {
  const estimatedFilingCost = useMemo(() => {
    let total = 0;
    for (const phase of phases) {
      for (const task of phase.tasks) {
        if (typeof task.estimated_cost === 'number') {
          total += task.estimated_cost;
        }
      }
    }
    return total;
  }, [phases]);

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Jurisdiction</h4>
        <dl className="mt-2 space-y-2 text-sm text-gray-700 dark:text-gray-300">
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Scope</dt>
            <dd>{formatJurisdictionLabel(template.jurisdiction)}</dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Court</dt>
            <dd>{template.jurisdiction?.court_name || 'Not specified'}</dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Case Subtype</dt>
            <dd>{template.case_subtype || 'Not specified'}</dd>
          </div>
        </dl>
      </div>

      <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Operational Data</h4>
        <dl className="mt-2 space-y-2 text-sm text-gray-700 dark:text-gray-300">
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Estimated Duration</dt>
            <dd>
              {typeof template.estimated_duration_days === 'number'
                ? `${template.estimated_duration_days} days`
                : 'Not specified'}
            </dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Complexity</dt>
            <dd>{template.complexity_level || 'Not specified'}</dd>
          </div>
          <div>
            <dt className="text-gray-500 dark:text-gray-400">Estimated Filing Cost</dt>
            <dd>{estimatedFilingCost > 0 ? currencyFormatter.format(estimatedFilingCost) : 'Not specified'}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default TemplateDetailCourtInfo;

